export default "dist/images/block-card-horizontal.7f9e380.png";